import intersection from 'lodash/intersection';
import { createSelector } from 'reselect';
import { getBulkConversationIDs } from 'components/bulkActions/selectors/bulkActions';
export const getConversationOverviewState = (state) => {
    return state.conversationsOverview;
};
export const getConversationOverviewBulkValidation = (state) => {
    return getConversationOverviewState(state).bulkValidation;
};
export const getConversationOverviewBulkAllIDs = (state) => {
    return getConversationOverviewState(state).bulkAllIDs;
};
export const getConversationOverviewBulkTotalConversations = (state) => {
    return getConversationOverviewState(state).bulkTotalConversations;
};
export const getConversationOverviewBulkIDsStatus = (state) => {
    return getConversationOverviewState(state).bulkIDsStatus;
};
export const getConversationOverviewBulkValidationForSelected = createSelector([getBulkConversationIDs, getConversationOverviewBulkValidation], (selectedConversations, bulkValidation) => bulkValidation.reduce((pre, cur) => {
    const intersect = intersection(selectedConversations, cur.csids);
    if (!intersect.length) {
        return pre;
    }
    return [...pre, Object.assign(Object.assign({}, cur), { csids: intersect })];
}, []));
